import { faSignOut } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  AppBar as MuiAppBar,
  Grid,
  IconButton,
  Link,
  SvgIcon,
  Toolbar,
  Typography,
} from '@mui/material';
import { useAuthentication } from '@onemedical/auth';

function AppBar({ userName }: { userName: string }) {
  const { logout } = useAuthentication();

  return (
    <MuiAppBar position="sticky">
      <Toolbar>
        <Grid container justifyContent="space-between" alignItems="center">
          <Grid item>
            <Link href="/home" color="inherit">
              <IconButton edge="start" color="inherit" size="large">
                <SvgIcon viewBox="0 0 92.1 92.1">
                  {/* eslint-disable-next-line max-len */}
                  <path d="M11.5,34.6A11.42,11.42,0,0,0,0,46,11.65,11.65,0,0,0,11.5,57.6,11.59,11.59,0,0,0,23.1,46.1h0A11.59,11.59,0,0,0,11.5,34.6Zm34.6,0A11.5,11.5,0,1,0,57.6,46.1h0A11.5,11.5,0,0,0,46.1,34.6Zm0,34.5A11.5,11.5,0,1,0,57.6,80.6h0A11.57,11.57,0,0,0,46.1,69.1ZM46.1,0A11.5,11.5,0,1,0,57.6,11.5h0A11.57,11.57,0,0,0,46.1,0ZM80.6,34.6A11.5,11.5,0,1,0,92.1,46.1,11.5,11.5,0,0,0,80.6,34.6Z" />
                </SvgIcon>
              </IconButton>
            </Link>
          </Grid>
          {userName && (
            <Grid item>
              <Typography>
                {userName}
                &nbsp;&nbsp;
                {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                <Link
                  href="#"
                  onClick={() =>
                    logout({ logoutParams: { returnTo: `${window.location.origin}/auth/logout` } })
                  }
                  color="inherit"
                >
                  <FontAwesomeIcon icon={faSignOut} />
                </Link>
              </Typography>
            </Grid>
          )}
        </Grid>
      </Toolbar>
    </MuiAppBar>
  );
}

export default AppBar;
